<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="user"
                                label="Select a faculty"
                                :rules="[formRules.required]"
                                @update:model-value="initFacultySubmission"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="facultyData"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                clearable
                                :readonly="action == 'edit' && user?.length !== 0"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col v-if="user != null" class="text-right" cols="12" md="8">
                            <v-btn
                            @click="showAddDialog()"
                            prepend-icon="mdi-plus"
                            class="mt-1 rounded-lg"
                            color="routesColor"
                            height="40px"
                            elevation="2">
                                Add Compliance Submission
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="mt-n3">
                            <v-card v-if="user == null" elevation="3">
                                <v-card-text>
                                    Please select a faculty
                                </v-card-text>
                            </v-card>
                            <v-card v-else class="dt-container">    
                                <v-data-table
                                    :mobile="isMobileOrTablet()"
                                    :headers="headers"
                                    :items="data"
                                    :loading="loading"
                                    :items-per-page="15"
                                    :items-per-page-options="[15,30, 50, 100, -1]"
                                >
                                <template v-slot:loading>
                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                </template>
                                <template v-slot:item.title="{ item }">
                                    <div class="text-truncate" style="max-width: 150px;">
                                        {{ item.title }}
                                    </div>
                                </template>
                                <template v-slot:item.is_approved="{ item }">
                                    <v-chip v-if="item.is_approved == true" size="small" color="green" variant="elevated">
                                        Yes
                                    </v-chip>
                                    <v-chip v-else size="small" color="gray">
                                        No
                                    </v-chip>
                                </template>
                                <template v-slot:item.date_submitted="{ item }">
                                    <span>{{ formatDate(item.date_submitted)}} </span>
                                </template>
                                <template v-slot:item.checkedBy="{ item }">
                                    <span v-if="item.checkedBy">{{ getItemTitle(item.checkedBy) }}</span>
                                    <span v-else>No Record</span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <div v-if="item.checkedBy.id == $store.state.user.id" class="d-flex justify-end ga-2">
                                        <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                    </div>
                                </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Close" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want remove this course?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteCourse()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <CheckingComplianceDialog ref="CheckingComplianceDialog" @refresh="initFacultySubmission()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import CheckingComplianceDialog from './Sub-Dialogs/CheckingComplianceDialog.vue';

export default defineComponent({
    emits: ["refresh"],
    components: {
        CheckingComplianceDialog
    },
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,
            data: [],

            headers: [
                { title: 'Course Code', align: 'start', sortable: true, key: 'facultyLoad.code' },
                { title: 'Course Title', align: 'start', sortable: true, key: 'facultyLoad.title' },
                { title: 'Section Code', align: 'start', sortable: true, key: 'facultyLoad.section_code' },
                { title: 'Submitted Date', align: 'start', sortable: true, key: 'date_submitted'},
                { title: 'Checked By', align: 'start', sortable: true, key: 'checkedBy' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            facultyData: [],
            user: null,
            complianceData: [],

            confirmDelete: false,
            itemToDelete: null,
        }
    },
    methods: {
        initAdd(compliance){
            this.dialog = true
            this.dialog_title = 'Faculty Compliance Checking (' + compliance.compliance_name + ')'
            this.dialog_sub_title = 'Compliance checking for "' + compliance.compliance_name + '"'
            this.action = 'add'
            this.complianceData = compliance
            this.initFaculty()
        },
        initUpdate(user, compliance){
            this.dialog = true
            this.dialog_title = 'Faculty Compliance Checking (' + compliance.compliance_name + ')'
            this.dialog_sub_title = 'Edit compliance checking for "' + compliance.compliance_name + '"'
            this.action = 'edit'

            this.user = user
            this.complianceData = compliance
            this.initFacultySubmission()
        },
        initFaculty(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findFacultyWithoutSubmissionByInstitute/' + this.$store.state.user?.office.id + '/' + this.complianceData.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.facultyData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        initFacultySubmission(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllCompliancesForUserBySemester/' + this.user?.id + '/' + this.complianceData.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        getItemTitle(item) {
            return `${item?.fname} ${item?.mname ? item?.mname[0] + '.' :''} ${item?.lname}${item?.suffix ? ', ' + item?.suffix : ''}` ;
        },
        showAddDialog(){
            this.$refs.CheckingComplianceDialog.initAdd(this.user, this.complianceData)
        },
        showEditDialog(data){
            this.$refs.CheckingComplianceDialog.initUpdate(data)
        },
        closeDialog(){
            this.user = null
            this.$emit('refresh')
            this.dialog = false
        },
    }
})
</script>

<style scoped>

</style>